import React, { Suspense, lazy, useContext, useEffect } from 'react';
import './App.scss';
import { RouterProvider, createHashRouter } from 'react-router-dom';
import Layout from './pages/Layout';
import Home from './pages/Home/Home';
import Loading from './components/Loading/Loading.jsx';
import AdminLayout from './pages/AdminLayout.jsx';
import { reactLocalStorage } from 'reactjs-localstorage';
import { useTranslation } from 'react-i18next';
import { UserContext } from './Context/UserContext.jsx';
import { jwtDecode } from "jwt-decode";
import Protector from './components/Protector/Protector.jsx';
import AdminProtector from './components/AdminProtector/AdminProtector.jsx';


const Contactus = lazy(() => import("./pages/Contactus/Contactus.jsx"));
const Productsinfo = lazy(() => import("./pages/Productsinfo/Productsinfo.jsx"));
const AppsFilter = lazy(() => import("./pages/AppsFilters/AppsFilter"));
const AdminLogin = lazy(() => import('./pages/Admin/Login/Login.jsx'));
const Policy = lazy(() => import("./pages/Policy/Policy.jsx"));

const DashApps = lazy(() => import("./pages/Admin/DashApps/DashApps.jsx"));
const AppController = lazy(() => import("./components/AppsCrud/AppController/AppController.jsx"));

const DashAdmins = lazy(() => import("./pages/Admin/DashAdmins/DashAdmins.jsx"));
const AdminController = lazy(() => import("./components/AdminsCrud/AdminController/AdminController.jsx"));

const Categories = lazy(() => import('./pages/Admin/Categories/Categories.jsx'));
const CategoriesController = lazy(() => import("./components/CategoriesCrud/CategoriesController/CategoriesController.jsx"));

const ContactsDash = lazy(() => import('./pages/Admin/ContactsDash/ContactsDash.jsx'));
const ContactsDashboard = lazy(() => import('./components/ContactsDashboard/ContactsDashboard.jsx'));

const NotFound = lazy(() => import("./pages/NotFound/NotFound.jsx"));

function App() {

  const { i18n } = useTranslation();
  const { setUserInformation } = useContext(UserContext);

  const routers = createHashRouter([
    { path: "*", element: <NotFound /> },
    {
      path: '', element: <Layout />, children: [
        { index: true, element: <Home /> },
        { path: "Apps", element: <Suspense fallback={<Loading />}><AppsFilter /> </Suspense> },
        { path: "Contactus", element: <Suspense fallback={<Loading />}><Contactus /> </Suspense> },
        { path: "AppInfo/:AppId", element: <Suspense fallback={<Loading />}><Productsinfo /> </Suspense> },
        { path: "Policy", element: <Suspense fallback={<Loading />}><Policy /> </Suspense> },
        { path: "*", element: <NotFound /> }
      ]
    },
    {
      path: '', element: <AdminLayout />, children: [

        { path: "Login2030", element: <Suspense fallback={<Loading />}><AdminLogin /> </Suspense> },
        {
          path: "DashApps2030", element:
            <Protector><Suspense fallback={<Loading />}><DashApps /></Suspense></Protector>,
          children: [{
            index: true,
            element: <Protector><Suspense fallback={<Loading />}><AppController /></Suspense></Protector>
          },
          { path: "*", element: <NotFound /> },
          ]
        },
        {
          path: "Admins", element:
            <Protector><AdminProtector><Suspense fallback={<Loading />}><DashAdmins /> </Suspense></AdminProtector></Protector>,
          children: [
            {
              index: true, element: <Protector><Suspense fallback={<Loading />}><AdminController /> </Suspense></Protector>
            },
            { path: "*", element: <NotFound /> },
          ]
        },
        {
          path: "Categories", element: <Protector><Suspense fallback={<Loading />}><Categories /></Suspense></Protector>,
          children: [
            {
              index: true, element: <Protector><Suspense fallback={<Loading />}><CategoriesController /></Suspense></Protector>
            },
            { path: "*", element: <NotFound /> },
          ]
        },
        {
          path: "ContactMessages",
          element: <Protector><Suspense fallback={<Loading />}><ContactsDash /></Suspense></Protector>,
          children: [
            {
              index: true,
              element: <Protector><Suspense fallback={<Loading />}><ContactsDashboard /></Suspense></Protector>,
            },
            { path: "*", element: <NotFound /> },
          ],
        },
      ]
    }
  ]);

  const MainLanguage = reactLocalStorage.get("lan");
  useEffect(() => {
    if (MainLanguage) {
      i18n.changeLanguage(MainLanguage.toLowerCase());
    }
  }, []);

  const token = reactLocalStorage.get("token");

  useEffect(() => {
    if (token) {
      setUserInformation(jwtDecode(token));
    }
  }, [token, setUserInformation])

  return <>
    <RouterProvider router={routers}>
    </RouterProvider>
  </>
}
export default App;